import styled from "styled-components";

export const StyledBalanceReport = styled.div` 
    font-family: var(--bllink-font-primary);

    .ScrollbarsCustom-Content {
        padding-right: 20px !important;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'}
    }

    .page-title {
        font-size: 26px;
        line-height: 30px;
    }
    
    .building-address {
        margin-inline-start: 10px;
        color: var(--bllink-purple);
    }
    
    .balance-subtitle {
        margin-top: 12px;
        font-weight: 700;
        font-size: 20px;
        line-height: 23px;
        color: rgba(55, 54, 71, 0.7);
    }

    .report-top {
        display: grid;
        grid-template-columns: 1fr 2fr 1fr 1fr;
        gap: 30px;
        align-items: center;
        position: relative;
        margin-top: 60px;
        margin-right: ${(({ ltr }) => ltr ? '' : '30px')};

        .search input {
            max-width: 200px;
        }

        .datepickers-container {
            display: flex;
            gap: 28px;

            .input-item label {
                text-align: start;
            }
        }

        .datepicker-label {
            position: absolute;
            top: -30px;
        }
    }

    .balance-container {
        border: 1px solid var(--bllink-purple);
        border-radius: 25px;
        padding: 24px 50px;
        margin-bottom: 10px;

        .account-info {
            display: flex;
            align-items: center;
            gap: 35px;

            .input {
                flex-direction: row;

                .bllink-input-border {
                    height: 34px;
                    width: 130px;
                    border-radius: 11px;
                }
            }


            .update-btn {
                width: 130px;
                padding: 7px 27px;
                border-radius: 11px;
            }

            .refresh {
                margin-inline-start: 5px;
            }
        }

        .styled-title {
            font-weight: 700;
            font-size: 18px;
            padding-inline-start: 20px;
        }

        .actual-balance {
            color: rgba(55, 54, 71, 0.7);
            font-size: 14px;
            line-height: 25px;
            padding-inline-start: 20px;
        }

        .balance-records-block {
            margin-top: 20px;

            .columns-titles {
                width: 80%;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                font-weight: 700;
                font-size: 16px;
                margin-top: 7px;
                margin-bottom: 12px;
                padding-inline-start: 20px;
                padding-inline-end: 15px;
                color: rgba(55, 54, 71, 0.7);
            }

            .balance-records {
                display: flex;
                flex-direction: column;
                gap: 14px;
            }

            .total-opened-info {
                border-top: 1px solid #D8D2FF;
                margin-top: 14px;
                padding-top: 10px;
            }
        }

        .total-balance {
            margin-top: 17px;
            margin-inline-start: 20px;

            .bold-row {
                font-weight: 700;
                font-size: 18px;
                width: 80%;
                display: grid;
                grid-template-columns: repeat(4,1fr);
            }
        }
    }
`

export const StyledBalanceRecord = styled.div`
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    border: 1px solid #A8C0FF;
    border-radius: 11px;
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    padding: 13px 20px;
    width: 100%;
    color: rgba(55, 54, 71, 0.7);
    position: relative;

    .wrapper {
        width: 80%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);

        .total-highlited {
            font-weight: 700;
        }
    }

    .open-close-btn {
        position: absolute;
        right: ${({ ltr }) => ltr ? '12px' : ''};
        left: ${({ ltr }) => ltr ? '' : '12px'};
        top: 7px;
        width: 32px;
        height: 32px;
        background: #E9E9FD;
        border-radius: 50px;
        cursor: pointer;
        box-shadow: -2px 3px 7px 0px rgba(89, 102, 137, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            margin-top: ${({ showTotalIncomeRow, showTotalExpenseRow }) => showTotalIncomeRow || showTotalExpenseRow ? '0' : '3px'};
            transform: ${({ showTotalIncomeRow, showTotalExpenseRow }) => showTotalIncomeRow || showTotalExpenseRow ? 'rotate(180deg)' : ''};
        }
    } 
`
